module.exports = __webpack_public_path__ + "img/26.07b702b2.jpg";